export default __webpack_public_path__ + "static/media/msort_lista_td.47714636.md";